import { useContext } from "react";

import { ViewModeContext } from "./ViewMode.context";

export const useViewMode = () => useContext(ViewModeContext);
